import { render } from "./ProjectsList.vue?vue&type=template&id=0f4deca8&scoped=true"
import script from "./ProjectsList.vue?vue&type=script&lang=js"
export * from "./ProjectsList.vue?vue&type=script&lang=js"

import "./ProjectsList.vue?vue&type=style&index=0&id=0f4deca8&scoped=true&lang=css"
import "./ProjectsList.vue?vue&type=style&index=1&id=0f4deca8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\GlavTV\\Documents\\GitHub\\octagon_uz\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f4deca8"]])

export default __exports__